<template>
  <v-dialog
    v-model="dialog"
    :closeOnclickModal="true"
    :width="isDone? '328px': '896px'">
    <div class="dialog-container">
      <section v-show="!isDone">
        <div class="dialog-header">
          <h3>Add to Support Ticket</h3>
          <span>Attach this quote to a support ticket to continue.</span>
        </div>
        <div class="dialog-body flex">
          <div class="left flex-1">
            <h3>Existing Support Ticket</h3>
            <v-input
              v-model="search"
              placeholder="Search by Ticket ID, Title"
              @keyEnter="filterData" />
            <div class="mg-b-10 mg-t-10">
              <v-checkbox-group
                :borderBlock="true"
                :list="typeOptions" />
            </div>
            <span class="client">
              client
              <span>{{ form.customer ? form.customer.isrd_nm: '' }}</span>
            </span>
            <el-table
              :data="ticketList"
              stripe
              style="width: 100%"
              @row-click="rowClick">
              <!-- <el-table-column width="55">
                <template slot-scope="scope">
                  <span
                    :class="[selectIndex == scope.$index? 'radio-circle-checked': 'radio-circle' ]"
                  ></span>
                </template>
              </el-table-column> -->
              <el-table-column
                prop="subject"
                label="Title"></el-table-column>
              <el-table-column
                label="Type">
                <template slot-scope="scope">
                  <span class="span-checkbox">{{ scope.row.type_language }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="id"
                label="ID"></el-table-column>
            </el-table>
          </div>
          <div class="right flex-1">
            <h3>New Support Ticket</h3>
            <el-form
              ref="form"
              :rules="rules"
              :model="ticketForm">
              <div class="form-item">
                <span>Title</span>
                <el-form-item prop="subject">
                  <v-input v-model="ticketForm.subject" />
                </el-form-item>
              </div>
              <div class="form-item">
                <span>Remark</span>
                <v-input v-model="ticketForm.message" />
              </div>
              <div class="form-item">
                <span>Customer</span>
                <!--                <v-select-->
                <!--                  v-model="customerId"-->
                <!--                  :list="customerOptions"-->
                <!--                  :disabled="true"-->
                <!--                  :clearable="true" />           -->
                <v-select
                  v-model="customerId"
                  remote
                  nameGroup
                  :remoteMethod="remoteMethodUser"
                  :list="customerOptionsUser"
                  :disabled="true"
                  :clearable="true" />
              </div>
              <div class="form-item">
                <span>Assignee</span>
                <v-select
                  v-model="ticketForm.assignee_id"
                  :list="globalOptions.assignee" />
              </div>
            </el-form>
            <v-button
              type="primary"
              @click="createTicket">Create Ticket</v-button>
            <v-button
              type="success"
              @click="createTicket(3)">Create and Resolve Ticket</v-button>
          </div>
        </div>
      </section>
      <section
        v-show="isDone"
        class="done-container">
        <h3>Add to Support Ticket</h3>
        <p>The quote has been added to ticket.</p>
        <v-button
          type="primary"
          @click="onViewQuote">View Quote</v-button>
      </section>
    </div>
  </v-dialog>
</template>
<script>
import {mapActions, mapState} from 'vuex'
import MixinOptions from '@/mixins/options'
import MixinRules from '@/mixins/rules'
import { createGeneralTicket, getTicketRelationList, setTicketRelation } from '@/api/ticket'
export default {
  name: 'PaymentAddTicket',
  mixins: [MixinOptions, MixinRules],
  props: {
    form: {
      type: Object,
      default: () => ({
        customer: {
          isrd_nm: ''
        }
      })
    }
  },
  data() {
    return {
      dialog: false,
      typeOptions: [
        {
          name: 'General',
          id: 1
        },
        {
          name: 'Refer Case',
          id: 2
        }
      ],
      search: '',
      ticketForm: {
        subject: '',
        assignee_id: '',
        // customer_id: '',
        message: ''
      },
      ticketList: [],
      selectIndex: -1,
      newTicketId: 0
    }
  },
  computed: {
    ...mapState('common', ['customerOptionsUser']),

    productId() {
      return this.form.product_id || 11
    },
    orderId() {
      return this.form.id
    },
    customerId() {
      return this.form.customer_id
    },
    quoteNo() {
      return this.form.quotation_number
    },
    isDone() {
      return this.newTicketId
    },
  },
  created() {
    this.network().getTicketRelationList()
  },
  methods: {
    ...mapActions('common', ['setProductId', 'getCustomerOptionsPhone','setCustomerOptionNUll','getCustomerOptionsEmail','getCustomerOptionsUser']),

    remoteMethodUser(query) {
      if (query !== '') {
        this.getCustomerOptionsUser(query)
      } else {
        this.setCustomerOptionNUll()
      }
    },
    changeDialog() {
      this.newTicketId = 0
      this.dialog = !this.dialog
    },
    onViewQuote() {
      //   this.$router.push({
      //     path: '/tickets/detail',
      //     query: {
      //       ticket_id: this.newTicketId
      //     }
      //   })
      this.$router.push({
        path: '/records/quote/detail',
        query: {
          order_id: this.form.id,
          product_id: this.productId
        }
      })
    },
    rowClick({ id }) {
      //   this.selectIndex = row.index
      // 應該要調用 attach 接口
      // this.$router.push({
      //   path: '/tickets/detail',
      //   query: {
      //     ticket_id: row.id
      //   }
      // })
      this.network().setTicketRelation(id)
    },
    filterData() {
      this.network().getTicketRelationList()
    },
    createTicket(status) {
      this.$refs.form.validate(valid => {
        if(valid) {
          if(status) {
            this.network().createGeneralTicket({
              status: 3
            })
          } else {
            this.network().createGeneralTicket()
          }
        }
      })
     
    },
    network() {
      return {
        getTicketRelationList: async () => {
          const { data } = await getTicketRelationList({
            customer_id: this.customerId,
            search: this.search
          })
          this.selectIndex = -1
          data.map((item, index) => {
            item.index = index
            return item
          })
          this.ticketList = data
        },
        createGeneralTicket: async (params = {}) => {
          const { data } = await createGeneralTicket({
            ...this.ticketForm,
            quote_no: this.quoteNo,
            customer_id: this.customerId,
            ...params
          })
          this.newTicketId = data.id
        },
        setTicketRelation: async (id) => {
          const { data } = await setTicketRelation({
            id,
            quote_no: this.quoteNo
          })
          this.newTicketId = id
        },
      }
    }
  }
}
</script>
<style lang="scss" scoped>
    .dialog-container {
        .done-container {
            padding: 15px;
            h3 {
                padding-bottom: 5px;
            }
            p {
                padding-bottom: 15px;
                font-size: 16px;
            }
        }
    .dialog-header {
      padding: 15px;
      color: #616266;
      font-size: 16px;
      border-bottom: 1px solid #dddfe7;
      h3 {
        padding-bottom: 5px;
      }
    }
    .dialog-body {
      h3 {
        padding-bottom: 10px;
        font-size: 20px;
      }
      .left {
        padding: 15px 10px 15px 15px;
        border-right: 1px solid #dddfe7;

        .mg-t-10 {
          margin-top: 10px;
        }
        .mg-b-10 {
          margin-bottom: 10px;
        }
        .client {
          font-size: 16px;
          font-weight: 500;
          & > span {
            display: inline-block;
            padding-left: 5px;
            font-weight: 400;
          }
        }
      }
      .right {
        padding: 15px 15px 15px 10px;
      }
    }
  }
</style>